// extracted by mini-css-extract-plugin
module.exports = {"breakpoint-tablet":"(min-width: 520px)","carouselHorizontalMargin":"12px","container":"Gallery-module--container--ef30f5","carousel":"Gallery-module--carousel--6a8f99"};